module.exports = __webpack_public_path__ + "static/media/DSA AMP I.064206ad.png";